import Grid from '@material-ui/core/Grid';
import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import QuestionComponent from '../components/questions/QuestionComponent';
import { getEditModuleMetadata, updateModule, saveModule, saveQuestions, modeuleList } from 'src/actions/action.module';
import { QuestionWrapper } from '../styles/question';
import { ApplicationMain } from '../styles/common';
import LoaderComponent from 'src/components/common/loader.component';

class QuestionContainer extends React.Component<any, any> {
    state = {
        spacing: '16',
        moduleId: 0,
        editModuleMetadata: {}
    };
    constructor(props: any) {
        super(props);

        this.updateModule = this.updateModule.bind(this);
    }

    updateModule(data: any) {
        this.props.updateModule(data);
    }

    componentDidMount() {
        const url = window.location.href.split('/');
        const paramId = url[url.lastIndexOf('questions') + 1];

        if (paramId !== "") {
            this.setState({
                moduleId: paramId
            },
                () => this.getEditModuleMetadata());
        }
    }
    
    getEditModuleMetadata = () => {
        this.props.getEditModuleMetadata(this.state.moduleId);
    }

    render() { 
        return (
            <ApplicationMain>
                <LoaderComponent sending={this.props.show} />
                <QuestionWrapper>
                    <Grid container={true}>
                        <Grid item={true} xs={12}>
                            <div className="pageContainer questionScreen">
                                <QuestionComponent
                                    updateModule={this.updateModule}
                                    updateEditModuleMetadata={this.props.updateEditModuleMetadata}
                                    editModuleMetadata={this.props.editModuleMetadata}
                                    saveQuestions={this.props.saveQuestions}
                                    moduleId={this.props.moduleId}
                                    path={this.props.redirectTo}
                                    modules={this.props.modules}
                                    getModuleList={this.props.moduleList}
                                    getEditModuleMetadata={this.getEditModuleMetadata}
                                    isQuestionReviewRequired={this.props.loginUserData.isQuestionReviewRequired}
                                    userId={this.props.userId}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </QuestionWrapper>
            </ApplicationMain>
        );
    }
   
}

const mapStateToProps = (state: any) => {
    return {
        show: state.common.show,
        editModuleMetadata: state.model.editModuleMetadata,
        isUpdated: state.model.isUpdated,
        moduleId: state.model.moduleId,
        modules: state.model.models,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        getEditModuleMetadata: (moduleId: any) => dispatch(getEditModuleMetadata(moduleId)),
        updateModule: (data: any) => dispatch(updateModule(data)),
        saveModule: () => dispatch(saveModule()),
        saveQuestions: () => dispatch(saveQuestions()),
        redirectTo: (path: string) => dispatch(push(path)),
        moduleList: () => dispatch(modeuleList()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionContainer);



// WEBPACK FOOTER //
// ./src/containers/QuestionContainer.tsx